import { createSyntheticFile } from "../synthetic-file"
import { ExtFile } from "../types"
import { FileIdGenerator } from "../utils"
import { listOfErrors } from "../validation"

export const extFileMock = (id?: number): ExtFile => {
    return {
        id: id || FileIdGenerator.getNextId(),
        name: "fileName.ext",
        size: 28 * 1024 * 1024,
        type: "files-ui/mock",
        file: createSyntheticFile("fileName.ext", 28 * 1024 * 1024, "files-ui/mock"),
        errors: listOfErrors,
        uploadMessage: "uploaded",
        uploadStatus: "preparing",
        valid: false,
        progress: 28,
        xhr: new XMLHttpRequest(),
        extraData: {
            extraData1: "files-ui is the best",
            extraData2: {
                id: 1,
                name: "files-ui.mock"
            },
            deleted: true
        },
        downloadUrl: "https://www.files-ui.com/mock/file-download",
        uploadUrl: "https://www.files-ui.com/mock/file"
    }
}


export const extFileMockArray = (amount = 2): ExtFile[] => {
    let arr = Array.from(Array(amount).keys());
    const arrResult: ExtFile[] = [];
    for (let i in arr) {
        arrResult.push(extFileMock());
    }
    return arrResult;
}